import React, {useState} from "react";
import {Checkbox, FormControlLabel, Grid, Modal} from "@mui/material";
import "./reviewScoreCard.scss";
import PropTypes from "prop-types";

const ReviewScoreCard = ({onSelectCriteria}) => {
    const [selectedScoreCards, setSelectedScoreCards] = useState([]);

    const checkboxOptions = [
        { id: '1', name: 'Communication & Engagement' },
        { id: '2', name: 'Question Handling' },
        { id: '3', name: 'Forward Motion' },
        { id: '4', name: 'Empathy' },
        { id: '5', name: 'Confidence' },
        { id: '6', name: 'Energy' }
    ];
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        const index = selectedScoreCards.indexOf(name);

        if(checked && index === -1) {
            setSelectedScoreCards(scoreCards => [...scoreCards, name])
        } else if(!checked && index !== -1) {
            setSelectedScoreCards(scoreCards => scoreCards.splice(index, 1))
        }
    };


    return <div className={"choose-criteria-container"}>
        <p className={"steps-title"}>Review Score Card</p>
        <p style={{alignSelf: "flex-start"}}>Score Card 1</p>
        <Grid container spacing={2} className={"score-cards-container"} sx={{width: "100%"}}>
        {
            checkboxOptions.map(({id, name}) => (
                <Grid item md={6} xs={12}>
                    <div className={`score-card ${selectedScoreCards.indexOf(id) !== -1 ? 'gradient-border' : ''}`}>
                        <FormControlLabel
                            key={id}
                            value="start"
                            control={<Checkbox checked={id ==='1' || id=== "2"} style={{color: "#E28A9C"}} disabled={true} onClick={handleCheckboxChange}/>}
                            label={name}
                            name={id}
                            labelPlacement="start"
                        />
                    </div>
                </Grid>
            ))
        }
        </Grid>

        <div>
        {/*<button className={`colored-button medium-font-size ${selectedScoreCards.length === 0 ? "disabled-button" : ""}`}*/}
        {/*        style={{width: '250px'}}*/}
        {/*        >*/}
        {/*    Create Custom Criteria*/}
        {/*</button>*/}

            <button className={`colored-button medium-font-size ${selectedScoreCards.length === 0 ? "disabled-button" : ""}`}
                    style={{width: '250px'}} onClick={onSelectCriteria}
            >
                Generate Call Score
            </button>
        {/*<button disabled={selectedScoreCards.length === 0}*/}
        {/*        title={selectedScoreCards.length === 0 ? "Please select at least one call score criteria" : ""}*/}
        {/*        className={`colored-button medium-font-size ${selectedScoreCards.length === 0 ? "disabled-button" : ""}`}*/}
        {/*        style={{width: '250px'}}*/}
        {/*        onClick={onSelectCriteria}>*/}
        {/*    Generate Call Score*/}
        {/*</button>*/}
        </div>
    </div>
}

export default ReviewScoreCard;

ReviewScoreCard.prototype = {
    onSelectCriteria: PropTypes.func
}